export var contains = function (item, arr) {
    return arr.indexOf(item) !== -1;
};
export var degreeToRadian = function (degree) {
    return degree * Math.PI / 180;
};
export function safeObjCopy(data) {
    return JSON.parse(JSON.stringify(data));
}
export var getDictFirstKey = function (dict) {
    for (var key in dict) {
        return key;
    }
    return null;
};
export var getDictFirstVal = function (dictSourceVals, dictSourceKeys) {
    var res = null;
    var firstKey = getDictFirstKey(dictSourceKeys || dictSourceVals);
    if (firstKey) {
        res = dictSourceVals[firstKey];
    }
    return res;
};
export var utf8Encode = function (value) {
    value = value.replace(/\r\n/g, '\n');
    var utftext = '';
    for (var n = 0; n < value.length; n++) {
        var c = value.charCodeAt(n);
        if (c < 128) {
            utftext += String.fromCharCode(c);
        }
        else if (c > 127 && c < 2048) {
            utftext += String.fromCharCode((c >> 6) | 192);
            utftext += String.fromCharCode((c & 63) | 128);
        }
        else {
            utftext += String.fromCharCode((c >> 12) | 224);
            utftext += String.fromCharCode(((c >> 6) & 63) | 128);
            utftext += String.fromCharCode((c & 63) | 128);
        }
    }
    return utftext;
};
export var utf8Decode = function (utftext) {
    var string = '';
    var i = 0;
    var c = 0;
    var c2 = 0;
    var c3 = 0;
    while (i < utftext.length) {
        c = utftext.charCodeAt(i);
        if (c < 128) {
            string += String.fromCharCode(c);
            i++;
        }
        else if (c > 191 && c < 224) {
            c2 = utftext.charCodeAt(i + 1);
            string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
            i += 2;
        }
        else {
            c2 = utftext.charCodeAt(i + 1);
            c3 = utftext.charCodeAt(i + 2);
            string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
            i += 3;
        }
    }
    return string;
};
export var safeBtoa = function (val) { return btoa(utf8Encode(val)); };
export var safeAtob = function (val) { return utf8Decode(atob(val)); };
